'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ALIGN_CLASSES = exports.ALIGN_CLASSES = {
  baseline: 'align-baseline',
  center: 'align-center',
  end: 'align-end',
  start: 'align-start',
  stretch: 'align-stretch'
};

var ALIGN_SELF_CLASSES = exports.ALIGN_SELF_CLASSES = {
  auto: '',
  baseline: 'align-self-baseline',
  center: 'align-self-center',
  end: 'align-self-end',
  start: 'align-self-start',
  stretch: 'align-self-stretch'
};

var DIRECTION_CLASSES = exports.DIRECTION_CLASSES = {
  'column': 'flex-column',
  'row': ''
};

var JUSTIFY_CLASSES = exports.JUSTIFY_CLASSES = {
  around: 'justify-around',
  between: 'justify-between',
  center: 'justify-center',
  end: 'justify-end',
  start: 'justify-start'
};

var WRAP_CLASSES = exports.WRAP_CLASSES = {
  'nowrap': '',
  'wrap': 'flex-wrap'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/layout/FlexConstants.js
// module id = 138
// module chunks = 0 1